import React, { useState } from 'react'

import { useTranslations } from '@dfb/gatsby-dfb-theme/src/hooks/useTranslations'

import DfbHeadline from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_headline'
import DfbInput from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_input'
import DfbSelect from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_select'
import DfbInputTextarea from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_input_textarea'
import DfbParagraph from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_paragraph'
import DfbRte from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_rte'
import MDefaultform from '../m_defaultForm'
import { checkRequireLabel } from '../../../../../../utils/form/checkRequireLabel'
import { extractFields } from '../../../../../../utils/form/extractFields'
import { emailRegex } from '../../../../../../utils/form/emailRegex'

const MContactForm = ({ data }) => {
  const t = useTranslations()
  const subjects = [
    {
      name: 'Fan Club Nationalmannschaft',
      identifier: 'FanClubNationalmannschaft',
      items: [
        {
          id: 0,
          name: 'Frage zu bestehender Mitgliedschaft',
          showMembernumber: true,
        },
        {
          id: 1,
          name: 'Bonuspunkte',
          showMembernumber: true,
        },
        {
          id: 2,
          name: 'Login in meinen Fan Club Account',
          showMembernumber: true,
        },
        {
          id: 3,
          name: 'Sonstige Frage zum Fan Club',
          showMembernumber: true,
        },
        {
          id: 4,
          name: 'Fantastic Moments',
        },
        {
          id: 5,
          name: 'Veranstaltungen des Fan Clubs',
        },
        {
          id: 6,
          name: 'Kündigung der Mitgliedschaft',
          showMembernumber: true,
          showBirthdate: true,
        },
      ],
    },
    {
      name: 'Fanbase',
      identifier: 'fanbase',
      items: [
        {
          id: 0,
          name: 'Frage zu bestehender Mitgliedschaft',
        },
        {
          id: 1,
          name: 'Sonstige Frage zur Fanbase',
        },
      ],
    },
    {
      name: 'Eigenständige Fan Clubs',
      identifier: 'eigenstaendigeFanClubs',
      items: [
        {
          id: 0,
          name: 'Neugründung',
        },
        {
          id: 1,
          name: 'Mitgliederliste aktualisieren',
        },
        {
          id: 2,
          name: 'Ticketbestellung',
        },
        {
          id: 3,
          name: 'Sonstige Frage',
        },
      ],
    },
    {
      name: 'Paule Kids Club',
      identifier: 'pauleKidsClub',
      items: [
        {
          id: 0,
          name: 'Frage zu bestehender Mitgliedchaft',
        },
        {
          id: 1,
          name: 'Sonstige Frage zum Paule Kids Club',
        },
      ],
    },
    {
      name: 'mein.DFB-Account',
      identifier: 'dfbaccount',
      items: [
        {
          id: 0,
          name: 'mein.DFB Registrierung/Login',
        },
        {
          id: 1,
          name: 'Namensänderung',
        },
        {
          id: 2,
          name: 'Sonstige Frage',
        },
      ],
    },
    {
      name: 'Sonstige Fananfragen',
      identifier: 'sonstigeFanAnfragen',
      items: [
        {
          id: 0,
          name: 'Feedback zu Länderspielen',
        },
        {
          id: 1,
          name: 'Reporting FB 3. Liga und GPFBL',
        },
        {
          id: 2,
          name: 'Fragen zu Länderspielen',
        },
        {
          id: 3,
          name: 'Allgemeine Themen',
        },
      ],
    },
    {
      name: 'Ticketing',
      identifier: 'Ticketing',
      items: [
        {
          id: 0,
          name: 'Stornierung & Umbuchung',
        },
        {
          id: 1,
          name: 'Tickets',
        },
        {
          id: 2,
          name: 'Tickets nicht erhalten',
        },
        {
          id: 3,
          name: 'Sonderkarten',
        },
        {
          id: 4,
          name: 'Login und Stammdaten',
        },
        {
          id: 5,
          name: 'Fan Club Nationalmannschaft',
        },
        {
          id: 6,
          name: 'Mobilität',
        },
        {
          id: 7,
          name: 'Rechnung',
        },
        {
          id: 8,
          name: 'Sonstiges',
        },
      ],
    },
  ]

  const formType = data.form_definition[0].identifier
  const fields = extractFields(data.form_definition[0].form_field)
  const [subjectOptions, setSubjectOptions] = useState([])
  const [currentIdentifier, setCurrentIdentifier] = useState('')
  const [showMembernumber, setShowMembernumber] = useState(false)
  const [showBirthdate, setShowBirthdate] = useState(false)
  const [email, setEmail] = useState('')
  const identifierObject = []

  data.form_recipient.forEach((recipient) => {
    identifierObject.push({
      name: recipient.name,
      identifier: recipient.identifier,
    })
  })

  const handleCategoryChange = (event, resetField) => {
    const currentSubject = subjects.find((subject) => subject.name === event.target.value)
    setSubjectOptions(currentSubject?.items || [])

    resetField('subject')
    setShowMembernumber(false)
    setShowBirthdate(false)

    identifierObject.forEach((item) => {
      if (item.name === event.target.value) {
        setCurrentIdentifier(item.identifier)
      }
    })
  }

  const handleSubjectChange = (subject, category) => {
    const item = subjects[0]?.items?.find((item) => item.name === subject)
    setShowMembernumber(category === subjects[0]?.name && item?.showMembernumber)
    setShowBirthdate(category === subjects[0]?.name && item?.showBirthdate)
  }

  return (
    <MDefaultform
      buttonLabel="Anfrage absenden"
      postUrl={process.env.FORM_API_URL}
      disableCaptcha={data.form_definition[0].captcha === 0}
      identifier={currentIdentifier}
      DOImail={email}
      formType={formType}
    >
      {({ register, errors, getValues, resetField }) => (
        <>
          {data.headline && <DfbHeadline headline={data.headline} headline_level="h3" add_class="m-Formblock-headline" />}
          {data.text && <DfbRte text={data.text} add_class="m-Formblock-text" />}
          {data.form_recipient && (
            <div className="m-Formblock-input-half">
              {data.form_recipient.length >= 1 && (
                <div className="m-Formblock-input">
                  <DfbSelect
                    {...register('category', {
                      required: t('form.errorMessages.select'),
                    })}
                    label="Kategorie der Anfrage*"
                    options={data.form_recipient.map(({ name, identifier }) => {
                      return { name, identifier }
                    })}
                    placeholder={t('form.placeholder.select')}
                    errorMessage={errors?.category?.message}
                    error={errors['category']}
                    onChange={(event) => handleCategoryChange(event, resetField)}
                  />
                </div>
              )}
              {subjectOptions.length > 1 && (
                <>
                  <div className="m-Formblock-input">
                    <DfbSelect
                      {...register('subject', {
                        required: t('form.errorMessages.select'),
                      })}
                      options={subjectOptions}
                      label="Betreff der Anfrage*"
                      placeholder={t('form.placeholder.select')}
                      errorMessage={errors?.subject?.message}
                      error={errors['subject']}
                      onChange={(event) => handleSubjectChange(event.target.value, getValues('category'))}
                    />
                  </div>
                </>
              )}
            </div>
          )}

          {fields.membernumber && showMembernumber && (
            <div>
              <div className="m-Formblock-input">
                <DfbInput
                  {...register(fields.membernumber.identifier, {
                    required: t('form.errorMessage.input'),
                  })}
                  error={errors[fields.membernumber.identifier]}
                  errorMessage={errors?.[fields.membernumber.identifier]?.message}
                  label={fields.membernumber.label + '*'}
                  focused
                />
              </div>
            </div>
          )}

          {fields.birthdate && showBirthdate && (
            <div>
              <div className="m-Formblock-input">
                <DfbInput
                  {...register(fields.birthdate.identifier, {
                    required: t('form.errorMessage.input'),
                  })}
                  error={errors[fields.birthdate.identifier]}
                  errorMessage={errors?.[fields.birthdate.identifier]?.message}
                  label={fields.birthdate.label + '*'}
                  focused
                />
              </div>
            </div>
          )}

          {(fields.firstname || fields.lastname || fields.email) && (
            <div className="m-Formblock-row-third">
              {[fields.firstname, fields.lastname].filter(Boolean).map((formItem, index) => (
                <div className="m-Formblock-row-third-cell" key={index}>
                  <DfbInput
                    {...register(formItem.identifier, {
                      required: formItem.required ? t('form.errorMessage.input') : false,
                    })}
                    error={errors[formItem.identifier]}
                    errorMessage={errors?.[formItem.identifier]?.message}
                    label={checkRequireLabel(formItem)}
                    focused
                  />
                </div>
              ))}
              <div className="m-Formblock-row-third-cell">
                <DfbInput
                  {...register(fields.email.identifier, {
                    required: fields.email.required ? t('form.errorMessage.input') : false,
                    pattern: {
                      value: emailRegex,
                      message: t('form.errorMessage.emailPattern'),
                    },
                    onChange: (e) => {
                      setEmail(e.target.value)
                    },
                  })}
                  error={errors[fields.email.identifier]}
                  errorMessage={errors?.[fields.email.identifier]?.message}
                  label={checkRequireLabel(fields.email)}
                  focused
                />
              </div>
            </div>
          )}

          {fields.message && (
            <div className="m-Formblock-input">
              <DfbInputTextarea
                {...register(fields.message.identifier, {
                  required: t('form.errorMessage.input'),
                })}
                label={checkRequireLabel(fields.message)}
                error={errors[fields.message.identifier]}
                errorMessage={errors?.message?.message}
              />
            </div>
          )}

          {fields.privacy && (
            <div className="m-Formblock-input">
              <DfbParagraph text={t('form.privacyText')} add_class="m-Formblock-text" />
            </div>
          )}
        </>
      )}
    </MDefaultform>
  )
}

export default MContactForm
